<template>
  <div class="estimation-link" @click="goMessage">
    <div v-if="consultUnreadCount > 0 || msgUnreadCount > 0" class="tip-circle"></div>
    <el-dropdown :teleported="false">
      <span class="iconfont icon-message"></span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="goToLink('consult')"
            >{{ $t('orderDetail.consult')
            }}{{ `${consultUnreadCount ? ` (${consultUnreadCount})` : ''}` }}</el-dropdown-item
          >
          <el-dropdown-item @click="goToLink('message')"
            >{{ $t('site.message')
            }}{{ `${msgUnreadCount ? ` (${msgUnreadCount})` : ''}` }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { useConsultStore, useUserStore } from '@/stores'
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const $route = useRoute()
const $router = useRouter()
const userStore = useUserStore()
const consultStore = useConsultStore()
const msgUnreadCount = computed(() => consultStore.msgInfo.unreadCount)
const consultUnreadCount = computed(() => consultStore.consultInfo.unreadCount)

const goToLink = (name) => {
  const params = {}
  $router.push({ name, query: params })
}
watch(
  () => $route.path,
  () => {
    userStore.isLogin && consultStore.updateAllMsgCount()
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
.estimation-link {
  cursor: pointer;
  font-size: 16px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .icon-message {
    text-align: center;
    color: var(--black-color-9);
    font-size: 22px;
    font-weight: 500;

    &:focus-visible {
      box-shadow: none;
      outline: none;
      border: none;
    }
  }
}

.tip-circle {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #f56c6c;
}

:v-deep {
  .el-dropdown {
    &:focus-visible {
      box-shadow: none;
      outline: none;
      border: none;
    }
  }
}
</style>
